import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";
import { initSentry } from "./lib/telemetry/sentry";
import { initAnalytics } from "./lib/telemetry/analytics";

// Initialize telemetry before mounting React. Both initializers are no-ops
// when their respective env vars are absent, so this is safe in every
// environment.
initSentry();
initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
